import initApp from './modules/initApp';
import initMobileMenu from './modules/mobile-menu';
import modal from './modules/modal';
import popup from './modules/popup';
import initFields from './modules/initFields';
//import bannerInit from './modules/banner';
//import fetchData from './modules/fetchData';













/*




const pageClass = document.body.classList;



const modalTriggers = document.querySelectorAll('[data-modal]');
if (modalTriggers) {
	modalTriggers.forEach(function(item) {
		item.addEventListener('click', modal);
	})
}
const popupTriggers = document.querySelectorAll('[data-popup]');
if (popupTriggers) {
	popupTriggers.forEach(function(item) {
		item.addEventListener('click', popup);
	})
}

const formElem = document.querySelector('.form__form');
if (formElem) {
	initFields(formElem, '.field', 'field--not-empty');
}

*/

const jsTestBtn = document.querySelector('.tests-list__submit');
if (jsTestBtn) {
    jsTestBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const answers = document.querySelectorAll('.tests-list__input');
        const questions = document.querySelectorAll('.tests-list__item');
        questions.forEach(question => {
            question.classList.remove('tests-list__item--error');
        });
        let errors = 0;
        answers.forEach(answer => {
            if (answer.checked && answer.dataset.isCorrect === "N") {
                //ошибки
                answer.closest('.tests-list__item').classList.add('tests-list__item--error');
                errors++;
            } 
        })
        if (errors > 0) {
            return
        } else {
            //ошибок нет, отправляем на сервер
            console.log('Everything is OK');
            //функция отправки данных формы. Передаем форму
            //sendResults(jsTestBtn.closest('.tests-list'));
            $('.js-tests-list').append('<input type="hidden" name="testsubmit" value="test_submit" />');
			$('.js-tests-list').submit();
        }
    })
}

